/** @format */

import template from './gb-table-item.html';
import './gb-table-item.scss';

export const GbTableItemComponent = {
    template,
    require: {
        gbItemTableWidget: '^^',
    },
    bindings: {
        item: '<',
    },
    controller: class GbTableItemComponent {
        constructor($interval, $scope, $gbBiddingItem) {
            'ngInject';

            this.$interval = $interval;
            this.$scope = $scope;
            this.$gbBiddingItem = $gbBiddingItem;

            this.currentWinnerIndex = 0;

            this.$winnerCycleDelay = 2000;
            this.$minWinnerCycleDelay = this.$winnerCycleDelay;
        }

        getBiddingItem() {
            if (this.item.item_type !== 'bidding') {
                return;
            }
            return this.item.getConcreteItemFromCache();
        }

        getPurchaseItem() {
            if (this.item.item_type !== 'purchase') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        getRaffleItem() {
            if (this.item.item_type !== 'raffle') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        getDonationItem() {
            if (this.item.item_type !== 'donation') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        stopWinnerCycle() {
            if (this.$winnerCycleTimer) {
                this.$interval.cancel(this.$winnerCycleTimer);
            }
        }

        getWinningBid() {
            if (this.item.item_type === 'bidding' && this.hasBiddingItem()) {
                return this.getBiddingItem().winning_bids[this.currentWinnerIndex];
            }
        }

        incrementIndex() {
            if (this.currentWinnerIndex >= this.getBiddingItem().winning_bids.length - 1) {
                this.currentWinnerIndex = 0;
            } else {
                this.currentWinnerIndex++;
            }
        }

        startWinnerCycle() {
            this.stopWinnerCycle();

            this.currentWinnerIndex = 0;

            let bidsAmount = this.getBiddingItem().winning_bids.length;

            if (bidsAmount <= 1) {
                return;
            }

            this.$winnerCycleDelay = this.gbItemTableWidget.$pageChangeDelay / bidsAmount;

            if (this.$winnerCycleDelay < this.$minWinnerCycleDelay) {
                this.$winnerCycleDelay = this.$minWinnerCycleDelay;
            }

            this.$winnerCycleTimer = this.$interval(() => {
                this.incrementIndex();
            }, this.$winnerCycleDelay);
        }

        $onInit() {
            if (this.item.item_type === 'bidding') {
                if (this.hasBiddingItem()) {
                    this.startWinnerCycleWatcher();
                } else {
                    this.biddingItemWatcher = this.$scope.$watch(
                        () => this.$gbBiddingItem.cache._v,
                        () => {
                            if (this.hasBiddingItem()) {
                                this.startWinnerCycleWatcher();
                                this.biddingItemWatcher();
                            }
                        }
                    );
                }
            }
        }

        startWinnerCycleWatcher() {
            if (this.hasBiddingItem()) {
                this.startWinnerCycle();
                this.$scope.$watch(
                    () => this.getBiddingItem().winning_bids.length,
                    (newVal, oldVal) => {
                        if (newVal !== oldVal) {
                            this.startWinnerCycle();
                        }
                    }
                );
            }
        }

        hasBiddingItem() {
            return !!this.getBiddingItem();
        }

        $onDestroy() {
            this.stopWinnerCycle();
        }

        shouldShowPurchaseItemAmountLabel() {
            const purchaseItem = this.getPurchaseItem();
            if (purchaseItem) {
                return purchaseItem.units_remaining > 0;
            }
            return false;
        }

        shouldShowRaffleRemainingTickets() {
            const raffleItem = this.getRaffleItem();
            if (raffleItem) {
                return raffleItem.show_number_of_tickets_available;
            }
            return true;
        }
    },
};
